import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=482cf72d&scoped=true"
var script = {}
import style0 from "./tips.vue?vue&type=style&index=0&id=482cf72d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cf72d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482cf72d')) {
      api.createRecord('482cf72d', component.options)
    } else {
      api.reload('482cf72d', component.options)
    }
    module.hot.accept("./tips.vue?vue&type=template&id=482cf72d&scoped=true", function () {
      api.rerender('482cf72d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/components/tips.vue"
export default component.exports